import { animateOnce } from "../utilities/animation.js";
import { createElement, createFragment } from "../utilities/elements.js";
import { defineElement } from "./registry.js";
import { DickTokStandaloneComponent } from "./StandaloneComponent.js";

export class DickTokMenuItem extends DickTokStandaloneComponent {
  static attributes = [
    { name: "icon-name", type: String, optional: true },
    { name: "icon-style", type: String, optional: true },
  ];

  static targets = ["container"];

  static template = createFragment(`
    <div
        class="dt-menuitem__container"
        data-target="container"
        data-action="click:dt-menuitem->pressed"
    >
        <slot></slot>
    </div>`);

  connectedCallback() {
    super.connectedCallback();
    this.#appendIcon();
  }

  #appendIcon() {
    if (this.hasIconName) {
      const style = this.iconStyle ?? "solid";
      const icon = createElement(
        `<i class="fa-sharp fa-${style} fa-${this.iconName} dt-menuitem__icon"></i>`,
      );
      this.containerTarget.prepend(icon);
    }
  }

  pressed() {
    animateOnce(this.containerTarget, "dt-menuitem__container--pressed");
  }
}

defineElement("dt-menuitem", DickTokMenuItem);
